<ng-container [ngSwitch]="filterInput.type">
    <form [formGroup]="filterForm">
        <input
            *ngSwitchCase="'date'"
            type="text"
            [placeholder]="filterInput.placeholder"
            class="form-control bordered mt-3"
            [formControlName]="filterInput.dbId"
            [bsConfig]="{
                dateInputFormat: 'YYYY-MM-DD',
                containerClass: 'custom-theme',
                showWeekNumbers: false
            }"
            bsDatepicker
        />
        <input
            *ngSwitchCase="'default'"
            type="text"
            [formControlName]="filterInput.dbId"
            [placeholder]="filterInput.placeholder"
            class="form-control bordered mt-3"
        />
        <select
            *ngSwitchCase="'select'"
            [formControlName]="filterInput.dbId"
            class="form-control mt-3"
            value="''"
        >
            <option
                *ngFor="let filterOption of filterInput.options"
                [value]="filterOption.value"
            >
                {{ filterOption.viewValue }}
            </option>
        </select>
    </form>
</ng-container>
